module.exports = __webpack_public_path__ + "static/media/demo-4.96a8f96e.jpg";